(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name main.dades.controller:DadesCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.usuaris.main.submain.dades')
    .controller('UsuarisMainDadesCtrl', UsuarisMainDadesCtrl);

  function UsuarisMainDadesCtrl(usuariData,$window, $rootScope,$stateParams,$state,HelperFactory,UsuariFactory,$scope,Notification) {
    var vm = this;
    vm.ctrlName = 'UsuarisMainDadesCtrl';
    vm.usuari=usuariData.data;

    //functions
    vm.changeToForm = changeToForm;
    vm.deleteElem = deleteElem;
    vm.viewProductesEntitat=viewProductesEntitat;
    vm.renew=renew;
    vm.unlock=unlock;

    function renew(idproducte,tipusclient,versio) {
      UsuariFactory.renew(vm.usuari.id,idproducte,tipusclient,versio).then(function(response){
        $scope.$evalAsync(function(){
          $state.go('usuaris.main.submain.dades', $stateParams, {'reload': 'usuaris.main.submain'});
        });
      }).catch(function(error){
        console.log(error);
        Notification.processError(error);
      });
    }
    
    function unlock() {
      UsuariFactory.unlock(vm.usuari.id).then(function(response){
        $scope.$evalAsync(function(){
          $state.go('usuaris.main.submain.dades', $stateParams, {'reload': 'usuaris.main.submain'});
        });
      }).catch(function(error){
        console.log(error);
        Notification.processError(error);
      });
    }
    

    function deleteElem() {
      $window.scrollTo(0, 0);
      $rootScope.$broadcast('usuaris.main.showOptionSubmenu', {'show': false});
      $rootScope.$broadcast('usuaris.main.delete', vm.usuari);
    }

    function changeToForm() {
      $window.scrollTo(0, 0);
      $rootScope.$broadcast('usuaris.main.showOptionSubmenu', {'show': false});
      $rootScope.$broadcast('usuaris.main.edit', vm.usuari);
    }
   

   if (angular.isUndefined($stateParams.idUsuari) || $stateParams.idUsuari === null || !$stateParams.idUsuari) {
      $rootScope.$broadcast('usuaris.main.showOptionSubmenu', {'show': false});
      $state.go('usuaris.main', $stateParams, {'reload': 'usuaris.main.submain'});
    }
    else {
      $rootScope.$broadcast('usuaris.main.showOptionSubmenu', {'show': true});
    }

    function viewProductesEntitat(identitat) {
      HelperFactory.setParams($stateParams, {'idEntitat': identitat});

      if(!angular.isUndefined($rootScope.permisos.PRODUCTEENTMENU) && $rootScope.permisos.PRODUCTEENTMENU.read){
              var url = $state.href('entitats.main.submain.llicencies', $stateParams, {'reload': 'entitats.main.submain'});
      }
      else if (!angular.isUndefined($rootScope.permisos.ENTITATMENU) && $rootScope.permisos.ENTITATMENU.read){
              var url = $state.href('entitats.main.submain.dades', $stateParams, {'reload': 'entitats.main.submain'});
      }
      
      $window.open(url,'_blank');
    }

  } 
}());
